export const RECEIPT_MODES = [
    'Cash', 'Cheque', 'Demand Draft', 'NEFT/RTGS', 'IMPS', 'Card', 'Others',
];
export const PAYMENT_MODES = RECEIPT_MODES;
export const CONTRA_MODES = ['NEFT/RTGS', 'IMPS', 'Cheque', 'Cash', 'Others'];

export const PAYMENT_TYPES = [
    { value: 'vendor', label: 'Vendor Payment' },
    { value: 'customer', label: 'Customer Refund' },
    { value: 'expense', label: 'Expense Payment' },
];

export const RECEIPT_AGAINST = [
    { value: 'invoice', label: 'Against Invoice' },
    { value: 'advance', label: 'Advance' },
    { value: 'on_account', label: 'On Account' },
];
export const PAYMENT_AGAINST = [
    { value: 'invoice', label: 'Against GRN / Invoice' },
    { value: 'advance', label: 'Advance' },
    { value: 'on_account', label: 'On Account' },
];

export function sumAllocation(lines, amountField) {
    return (lines || []).reduce((sum, line) => sum + (parseFloat(line[amountField]) || 0), 0);
}

export function roundMoney(value) {
    return Math.round((parseFloat(value) || 0) * 100) / 100;
}

export function allocationRemaining(totalAmount, allocatedTotal) {
    return roundMoney((parseFloat(totalAmount) || 0) - (parseFloat(allocatedTotal) || 0));
}

export function maxLineAllocation(line, lines, amountField, totalAmount, lineIndex) {
    const balance = parseFloat(line.balance_amt) || 0;
    const current = parseFloat(line[amountField]) || 0;
    const otherAllocated = (lines || []).reduce((sum, row, index) => {
        if (index === lineIndex) {
            return sum;
        }
        return sum + (parseFloat(row[amountField]) || 0);
    }, 0);
    const room = Math.max(0, roundMoney((parseFloat(totalAmount) || 0) - otherAllocated));
    return Math.min(balance, room);
}

export function parseLineDate(value) {
    if (!value) {
        return 0;
    }
    const parts = String(value).split('-');
    if (parts.length !== 3) {
        return 0;
    }
    const day = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10) - 1;
    const year = parseInt(parts[2], 10);
    return new Date(year, month, day).getTime();
}

export function sortLinesOldestFirst(lines, dateField = 'invoice_date') {
    return [...(lines || [])].sort((left, right) => {
        const dateDiff = parseLineDate(left[dateField] || left.reference_date)
            - parseLineDate(right[dateField] || right.reference_date);
        if (dateDiff !== 0) {
            return dateDiff;
        }
        const leftId = left.invoice_id || left.gmr_id || left.journal_id || 0;
        const rightId = right.invoice_id || right.gmr_id || right.journal_id || 0;
        return leftId - rightId;
    });
}

export function lineAllocationKey(line) {
    return line.invoice_id || line.gmr_id || line.journal_id || line.invoice_no || line.reference_no;
}

export function buildAutoAllocation(lines, amountField, totalAmount, dateField = 'invoice_date') {
    let remaining = parseFloat(totalAmount) || 0;
    const allocations = new Map();
    sortLinesOldestFirst(lines, dateField).forEach((line) => {
        const alloc = Math.min(remaining, parseFloat(line.balance_amt) || 0);
        remaining = roundMoney(remaining - alloc);
        allocations.set(
            lineAllocationKey(line),
            alloc > 0 ? alloc.toFixed(2) : '',
        );
    });
    return (lines || []).map((line) => ({
        ...line,
        [amountField]: allocations.get(lineAllocationKey(line)) || '',
    }));
}

/** Maps Cash/Bank Registration accounts for voucher pay-from / deposit dropdowns. */
export function getBankCashOptions(bankList) {
    return (bankList || [])
        .filter((account) => account.status)
        .map((account) => {
            const isCash = String(account.account_type || '').toLowerCase() === 'cash';
            const displayName = account.bank_alias || account.name;
            return {
                value: account.id,
                label: isCash ? `${displayName} (Cash)` : `${displayName} (Bank)`,
                account_type: account.account_type,
            };
        });
}

export function AccountingHintPanel({ hint }) {
    if (!hint) {
        return null;
    }
    return (
        <div className="form-row table-bordered shadow p-2 my-2 border-secondary p-2 mb-3 form-control-panel">
            <label className="form-group col-sm-2 text-right">Accounting</label>
            <div className="col-sm-10 small text-muted">
                <div>{hint.debit_ledger} · {hint.credit_ledger}</div>
                <div>{hint.narration}</div>
            </div>
        </div>
    );
}
